import React,{useState,useRef,useEffect} from 'react';
import DatePicker from "react-datepicker";
import Select from 'react-select'

import api from '../apiConnector'

import LegalDetails from './legalDetails';
import FieldYesNo from './fields/fieldYesNo';
import FieldSelect from './fields/fieldSelect';
import FieldNumeric from './fields/fieldNumeric';
import FieldDate from './fields/fieldDate';
import FieldText from './fields/fieldText';
import FormPage from './formPage';
import logo_motard from "../img/motard4.png"
import Vehiculier from './vehiculier';
import waiter from '../img/wait_white.svg';
import FieldCheck from './fields/fieldCheck'
import edit_button from '../img/edit.png'
import logo_permis from '../img/n de permis de conduire.svg'
import logo_immatriculation from '../img/immatriculation.png'
import logo_right from '../img/right.png'
import img_lamp from '../img/Ampoule bleu1.svg'
import img_cb from '../img/carte de crédit.svg'
import img_tools from '../img/tools-line.png'

import DataDevis from '../dataDevis';
import VehicleService from '../serviceAxaVehicules';
import {FrontEcheancierAxa} from './echeancier';
import echeancier from '../img/échéancier.svg'
import arrow_down from '../img/black_arrow_down.png'
import arrow_up from '../img/black_arrow_up.png'
import cadenas from '../img/Cadenas.svg'
import FieldAssureurs from './fields/fieldAssureurs'

/** FrontDetails2 - page d'informations spécifiques à AXA */

const VehiculePicker = ({marque,modele,cylindree,onChange}) => {
  
    const vehiclesRef = useRef(null);    
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        let mounted = true;

        VehicleService.getAxaVehicules()
        .then((data) => {
            if (mounted) {
                vehiclesRef.current = data;
                setIsLoaded(true);
            }
        })
        .catch((err) => console.error("Failed to load vehicles", err));

        return () => { mounted = false; };
    }, []);

    if (!isLoaded) return <div>Loading...</div>;

    const onMarqueChange = (e) => {
        const newMarque = e.value
        const newModele = vehiclesRef.current[newMarque][0] || ''
        onChange( { marque: newMarque, modele: newModele, cylindree:cylindree } )
    }

    const onModeleChange = (e) => {
        onChange( {modele:e.value, marque:marque, cylindree:cylindree} )
    }

    const onCylindreeChange = (e) => {
        onChange( {modele:modele, marque:marque, cylindree:e.target.value} )
    }

    return (
        <div className="vehicule_picker">
            <label>Marque</label>
            <Select placeholder="Marque" 
                value = { {value:marque,label:marque} }
                options = { Object.keys( vehiclesRef.current ).map( (m) => ({value:m,label:m}) ) }
                onChange = { onMarqueChange }
                translate = "no"
            />
            <label>Modèle</label>
            <Select placeholder="Modèle" 
                value = { {value:modele,label:modele} }
                options = { ( vehiclesRef.current[marque] || [] ).map( (m) => ({value:m,label:m}) ) }
                onChange = { onModeleChange }
                translate = "no"
            />
            <label>Cylindrée</label>
            <input className="text_input" type="text" value={cylindree} onChange={onCylindreeChange}/>
        </div>
    );
};

const MonthPicker = ({value,setValue})=><DatePicker 
    placeholderText="--" 
    showMonthYearPicker // This is the key prop
    showFullMonthYearPicker // Optional: cleaner UI
    dateFormat="MM/yyyy"  
    locale="fr" 
    selected={ DataDevis.paramToMonth(value) }
    onChange={(date)=> setValue(DataDevis.monthToParam(date)) } />

const HistoriqueVehiculesRow = ({data,onChange,action}) => (
    <tr>
        <td>
            <div style={{display:'flex'}}>
                <div>
                <label>Début</label>
                <MonthPicker value={data.beginDate} setValue={(date)=>onChange({beginDate:date})}/>
                </div>
                <div>
                <label>Fin</label>
                <MonthPicker value={data.endDate} setValue={(date)=>onChange({endDate:date})}/>
                </div>
            </div>
        </td>
        <td><VehiculePicker 
            {...data}
            onChange={onChange} /></td>
        <td>{action}</td>
    </tr> )

const INITIAL_FORM_STATE = {
    beginDate: null,
    endDate: null,
    marque: 'YAMAHA',
    modele: '',
    cylindree: ''
};


// Helper: Converts "mm/YYYY" into a total month integer (Year * 12 + Month)
const parseToAbsoluteMonths = (dateStr) => {
    const [month, year] = dateStr.split('/'); 
    // parseInt(month, 10) ensures '01' becomes 1. 
    // We don't need to subtract 1 for 0-indexing here because we only care about the difference.
    return (parseInt(year, 10) * 12) + parseInt(month, 10);
};

const getCurrentAbsoluteMonth = () => {
    const now = new Date();
    // getMonth() is 0-indexed (0=Jan), so we add 1 to match your "01/2023" format
    return (now.getFullYear() * 12) + (now.getMonth() + 1);
};

const calculateTotalMonths2 = (vehicles) => {
    return vehicles.reduce((total, vehicle) => {
        // 1. Guard clause: skip if dates are missing/invalid
        if (!vehicle.beginDate || !vehicle.endDate) return total;

        // 2. Parse the dates
        const startMonths = parseToAbsoluteMonths(vehicle.beginDate);
        const endMonths = parseToAbsoluteMonths(vehicle.endDate);

        // 3. Calculate duration (inclusive)
        // If start is 01/2023 and end is 01/2023, that is 1 month of coverage, not 0.
        const duration = (endMonths - startMonths) + 1;

        // 4. Add to accumulator, ensuring we don't add negative numbers (if dates are swapped)
        return total + (duration > 0 ? duration : 0);
    }, 0);
};

const calculateTotalMonths = (vehicules) => {
    const minStart = getCurrentAbsoluteMonth()-23
    const ranges = vehicules.map((v, index) => {
        const end = parseToAbsoluteMonths(v.endDate)
        if ( end < minStart ) return false
            return ({
                originalIndex: index, // Keep track of who is who
                start: Math.max(parseToAbsoluteMonths(v.beginDate),minStart),
                end: end
        })}).filter( v => v );
    ranges.sort((a, b) => ( a.start - b.start )||( a.end - b.end ));
    let count = 0
    let contig_start = 0
    let contig_end = 0
    for (let i = 0; i < ranges.length ; i++) {
        if ( ! contig_start ) { contig_start = ranges[i].start ; contig_end = ranges[i].end }
        else { contig_end = Math.max( contig_end, ranges[i].end ) }
        if (( i >= ranges.length-1 )||( ranges[i+1].start > contig_end )) {
            // We are at the end of a continuous bloc
            count += contig_end - contig_start + 1
            contig_start = 0
        }
    }
    return count
}

const HistoriqueVehicules = ({container}) => {
    const {devis,focusError,showValidate} = container
    const {params} = devis
    const {hist_veh=[]} = params

    const [message,setMessage] = useState([false,-1])
    const [formVehicule, setFormVehicule] = useState(INITIAL_FORM_STATE);
    const prevHistVehLength = useRef(hist_veh.length);
    const ref = useRef(null)
    useEffect(() => {
        if (hist_veh.length > prevHistVehLength.current) {
            setFormVehicule(INITIAL_FORM_STATE);
        }
        prevHistVehLength.current = hist_veh.length;
    }, [hist_veh]); // Run this logic whenever hist_veh changes
        
    const formComplete = formVehicule.beginDate && formVehicule.endDate && formVehicule.marque && formVehicule.modele && formVehicule.cylindree;
    const formValid = formComplete && (parseToAbsoluteMonths(formVehicule.beginDate) <= parseToAbsoluteMonths(formVehicule.endDate));


    const validate = (vehicleList) => {

        const ranges = vehicleList.map((v, index) => ({
            originalIndex: index, // Keep track of who is who
            start: parseToAbsoluteMonths(v.beginDate),
            end: parseToAbsoluteMonths(v.endDate)
        }));

        const currentMonth = getCurrentAbsoluteMonth()
        if ( ranges.some( v => v.end > currentMonth ) ) {
            return 'La date de fin ne peut pas être dans le futur'
        }

        if ( ranges.some( v =>  v.start > v.end ) ) {
            return 'La date de fin doit se situer après la date de début'
        }

        /*
        ranges.sort((a, b) => ( a.start - b.start )||( a.end - b.end ));

        for (let i = 0; i < ranges.length - 1; i++) {
            const current = ranges[i];
            const next = ranges[i + 1];

            if (current.end > next.start) {
                return 'Cette période recoupe une autre période';
            }
        }
        */
        return false;
    };

    const updateList = ( newList, id ) => {
        const error = validate( newList )
        if ( !error ) {
            container.changeParams({ hist_veh: newList, nb_mois_moto: calculateTotalMonths(newList) });
            setMessage([false,-1])
        } else {
            setMessage([error,id])
        }
    }

    const handleAddClick = () => {
        updateList( [...hist_veh, formVehicule], -1 )
    }

    const handleDelete = (idx) => {
        updateList( hist_veh.filter((_,index) => index !== idx ) )
    }

    const handleUpdate = (i,hv) => {
        updateList(
            hist_veh.map( (_hv, j ) => {
                if ( i === j ) return { ..._hv, ...hv }
                return _hv
            }), i
        );
    }

    const Error = ({message,index}) => ( message[0] &&( message[1]===index )&& <tr className="error" colSpan="3"><td colSpan="2">⚠ {message[0]}</td></tr> )

    const totalMonths = calculateTotalMonths( hist_veh )
    const inconsistent = params.nb_mois_moto != totalMonths

    const recapMessage = 
        inconsistent
            ? <>Vous aviez déclaré {params.nb_mois_moto} mois d'assurance durant les 24 derniers mois - merci de les détailler ici</>
        : !params.nb_mois_moto
            ? <>Durant ces 24 derniers mois, vous n'avez déclaré aucune période d'assurance</>
            : <>Durant ces 24 derniers mois, vous avez cumulé : {totalMonths} mois d'assurance</>

    if ( inconsistent ) focusError(ref)

    return <>
        <table className="historique_vehicule">
            <thead>
            <tr><th>Période</th><th>Véhicule assuré</th><th></th></tr>
            </thead>
            <tbody>
            { hist_veh.map( (hv,i) => <React.Fragment key={i}><HistoriqueVehiculesRow data={hv} 
                action={<button onClick={() => handleDelete(i)}>🗑️ Supprimer</button>}
                onChange={(_hv)=>handleUpdate(i,_hv)}
            /><Error message={message} index={i}/>
            </React.Fragment>) }
            <tr ref={ref}><th colSpan="3" className={'historique_vehicule_recap'+(( showValidate && inconsistent )? ' invalidbox' : '' )}>{recapMessage}</th></tr>
            {( hist_veh.length < 3 )&&<>
            <HistoriqueVehiculesRow data={ formVehicule } onChange={
                (hv)=>{
                    setMessage([false,-1])
                    setFormVehicule(prevState => ({
                        ...prevState, // Keep existing values
                        ...hv    // Overwrite with new ones (marque, modele, etc)
                    }))
                }}
                action={
                    <button 
                        onClick={handleAddClick} 
                        disabled={!formValid} // distinct visual state when disabled
                        className="btn-add"
                        >
                        ➕ Ajouter
                    </button>
                }
                />
                <Error message={message} index={-1}/>
                </>}
            </tbody>
        </table>
    </>
}

export default class FrontDetails2 extends FormPage {
    
    constructor(props) {
        super(props);
        this.title = 'Finalisons votre dossier'
        this.state = {
            showValidate:false,
            typeAddSinistre:false,
            dateAddSinistre:false,
            resyncing:false,
            vehiculierReady:false
        }
        const isMoto = this.props.devis.type == 'moto'
        this.vehiculier = isMoto ? new Vehiculier( this.props.devis.params.marque, ()=>{this.setState({vehiculierReady:true})} ) : false
        this.nextTitle = 'Payer et valider mon contrat'
        this.contactBoxOnTop = true
        this.timer = false
    }

    periodic() {
        const calculating = this.props.devis.axa?.calculating
        if ( calculating ) {
            this.props.checkStatus({'axa.calculating':calculating})
        } else {
            api.post(
                {action:'nop'}, // This does nothing but gets all by default information including axa status
                ()=>{}
            )
        }
    }

    componentDidMount() {
        this.timer = setInterval(
            this.periodic.bind(this),
            6000
        )
        this.componentDidUpdate()
    }


    componentWillUnmount() {
        if ( this.timer ) {
            clearInterval( this.timer )
            this.timer = false
        }
    }

    componentDidUpdate() {
        super.componentDidUpdate()
        if ( ! this.props.devis.validated ) {
            this.props.validateDevis('axa')
        }
        if ( this.props.devis.synchronized && this.state.resyncing ) {
            this.setState({resyncing:false})
        }
    }

    renderAnnulation(container) {
        return <>
            <FieldDate field="ant_annulation_date" container={container} />
        </>
    }

    renderStupefiants(container) {
        return <>
            <FieldDate field="ant_stupefiants_date" container={container} />
            <FieldText field="ant_stupefiants_substance" container={container} />
            <FieldSelect field="ant_stupefiants_sinistre" container={container} />
            <FieldYesNo field="ant_stupefiants_recidive" container={container} />
        </>   
    }

    renderAlcool(container) {
        return <>
            <FieldDate field="ant_alcool_date" container={container} />
            <FieldSelect field="ant_alcool_taux" container={container} />
            <FieldSelect field="ant_alcool_sinistre" container={container} />
            <FieldYesNo field="ant_alcool_recidive" container={container} />
        </>
    }

    renderRetrait(container) {
        return <>
            <FieldDate field="ant_retrait_date" container={container} />
            <FieldNumeric field="ant_retrait_duree_mois" container={container} min="0" max="36" />
            <FieldSelect field="ant_retrait_motif_full" container={container} />
            <FieldYesNo field="ant_retrait_recidive" container={container} />
        </>
    }

    renderResiliation(container) {
        return <>
            <FieldDate field="ant_resiliation_date" container={container} />
            <FieldYesNo field="ant_resiliation_non_paiement" container={container}/>
            <FieldYesNo field="ant_resiliation_fausse_declaration" container={container}/>
            <FieldYesNo field="ant_resiliation_frequence_sinistres" container={container}/>
            <FieldYesNo field="ant_resiliation_autre_motif" container={container}/>
        </>   
    }

    next() {
        const devis = this.props.devis
        if ( !devis.synchronized ) {
            if ( !this.state.resyncing ) {
                this.setState({resyncing:true})
                this.props.resync()
            }
        } else {
            const axa = devis.getAxa().setChoicesFromDevis()
            const hasAxa = axa.hasTarifs()
            if ( hasAxa && axa.valid_address ) this.props.setPage('payment2')
        }
    }

    back() {
        this.props.setPage('landing')
    }

    onAddSinistre() {
        if ( this.state.typeAddSinistre && this.state.typeAddSinistre.value && this.state.dateAddSinistre ) {
            this.props.devis.addSinistre( this.state.typeAddSinistre.value, this.state.dateAddSinistre, this.props.changeParams )
        }
    }

    renderGoToAntecedents() {
        return <a className="right_anchor" onClick={()=>this.props.setPage('antecedents')}><img src={edit_button}/> Modifier la liste de vos antécédents</a>
    }

    optionsMarque() {
        return this.state.vehiculier 
            ? Object.keys( this.state.vehiculier ).map( m => ({value:m,label:m}) )
            : []
    }

    optionsModele() {
        const {marque} = this.props.devis.params
        return ( this.state.vehiculier && marque )
            ? this.state.vehiculier[marque].map( m => ({value:m,label:m}))
            : []
    }

    optionsVersions() {
        const cont = (s,pr='',p='') => ( s &&( s != '-' ) ) ? pr+s+p+' ' : ''
        return this.state.versions ? this.state.versions.map( v => 
            ({ value:v.sra, label:cont(v.version)+cont(v.generation)+cont(v.energie,'- ')+cont(v.carrosserie,'- ')+cont(v.pa,'- ',' CV') } ) ) : []
    }

    doRender(container) {
        const {devis} = this.props
        const axa = devis.getAxa().setChoicesFromDevis().setFancy('-',' €')
        const params = devis.params
        const hasAxa = axa.hasTarifs()
        const noticeCondSecondaire = ( params.conducteur_2 == 'O' )?<b>vous ou le conducteur secondaire</b>:'vous'
        const isMoto = devis.type == 'moto'
        const antRetrait = params.ant_retrait=='O'
        const antAnnulation = params.ant_annulation=='O'
        const antAlcool = params.ant_alcool=='O'
        const antStupefiants = params.ant_stupefiants=='O'
        const antResiliation = params.ant_resiliation=='O'
        const unsync = ! devis.synchronized

        if ( this.state.vehiculierReady &&( params.marque != this.vehiculier.getMarque() )) {
            this.vehiculier.selectMarque( params.marque )
        }

        this.nextTitle = 'Payer et valider mon contrat'
        this.hasNext = true

        if ( axa.calculating || this.state.resyncing ) {
            this.nextTitle = <img src={waiter}/>
        } else if ( unsync ) {
            this.nextTitle = 'Valider'
        } else if (!( hasAxa && axa.valid_address )) {
            this.hasNext = false
        }
        
        return <>
            <div className="header_offre"><img src={logo_motard}/></div>

            <div className="contentvbox">

                                {(!axa.valid_address)&&<div className="notice_box">
                    <div className="img_box"><img src={cadenas}/></div>
                    <div className="text_box">
                        L'adresse postale est invalide (nom de rue incorrect ou adresse mal formée).                        
                    <a className="right_anchor" onClick={()=>this.props.setPage('vous')}>Merci de vérifier votre adresse ici</a>
                    </div>
                </div>}


            <h1 className="top_title">Vérifiez le modèle de votre véhicule</h1>

            <FieldSelect field="marque" container={container} options={ this.state.vehiculierReady ? this.vehiculier.getMarques() : []}/>
            <FieldSelect field="modele" container={container} options={ this.state.vehiculierReady ? this.vehiculier.getModeles() : []}/>
            <FieldText field="cylindree" container={container}/>

            { params.axa_modele && <p className={unsync?'stroke':''}>
                Modèle {params.axa_modele} {params.axa_cylindree}. Catégorie : {params.axa_category}. Puissance : {params.axa_power} kW. 
                Type : {params.axa_type} {unsync&&'*'}
            </p>}
            { params.axa_modele && unsync && <i>* Cliquez sur Valider en bas de page pour mettre à jour la fiche véhicule</i>}
            
            <br/>
            <a className="right_anchor" onClick={()=>this.props.setPage('vehicule')}><img src={edit_button}/> Vérifier l'ensemble des infos véhicule</a>

            {( params.formule !== 'M2' )&&                 <div className="notice_box">
                <div className="img_box"><img src={cadenas}/></div>
                <div className="text_box">
                <span style={{'fontSize':'1.2em'}}>
                Vous devez disposer d'un <b>ANTIVOL mécanique</b> de classe SRA et <b>Gravage</b> de classe SRA. En l'absence de facture,
                une déclaration sur l'honneur avec photo vous sera demandée. 
                </span>
                </div>
            </div>}

            </div>

            <div className="contentvbox">
            <h1 className="top_title">Historique de vos véhicules - 24 derniers mois</h1>

            <h3> Indiquez le détail des motos, motocyclettes, quadricycles lourds de plus de 50cm3 sur lesquels vous avez été assuré durant les 24 derniers mois.</h3>

            <HistoriqueVehicules container={container}/>

            </div>

            <div className="contentvbox">

            <h1 className="top_title">Quelques dernières précisions</h1>

            <FieldSelect field="situation_famille" container={container} />

            <LegalDetails container={container} />

            <h2>Type de stationnement</h2>

            <FieldYesNo field="mode_garage_rue" container={container}/>

            { params.mode_garage_rue == 'N' && <>
                <FieldYesNo field="mode_garage_prive" container={container}/>
                <FieldYesNo field="mode_garage_clos" container={container}/>
                <FieldYesNo field="mode_garage_couvert" container={container}/>
                </>
            }

            <h2>Pour cette offres, nous avons besoin de certains antécédents sur 5 ans</h2>

            <FieldYesNo field="ant_alcool" container={container} label={<>Au cours des 5 dernières années, vous avez fait l'objet d'une <b>sanction en état d'ébriété</b></>} />
            {( params.ant_alcool=='O' )? this.renderAlcool(container) : '' }

            <FieldYesNo field="ant_stupefiants" container={container} label={<>Au cours des 5 dernières années, vous avez fait l'objet de poursuites ou condamnations pour conduite sous l'emprise de <b>stupéfiants, drogues ou médicaments non prescrits</b></>} />
            {( params.ant_stupefiants=='O' )? this.renderStupefiants(container) : '' }

            <FieldYesNo field="ant_delit_fuite" container={container} label={<>Au cours des 5 dernières années, vous avez fait l'objet de poursuites ou condamnations pour <b>délit de fuite</b></>} />

            {antRetrait?<>
                <h3><span>Retraits de permis</span></h3>
                {this.renderGoToAntecedents()}
                <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'un retrait de permis</label>
                {( params.ant_retrait=='O' )? this.renderRetrait(container) : '' }
            </>:<></>}

            {antAnnulation?<>
                <h3><span>Annulation de permis</span></h3>
                <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'une annulation de permis</label>
                {( params.ant_annulation=='O' )? this.renderAnnulation(container) : '' }
            </>:<></>}


            {antResiliation?<>
                <h3><span>Résiliation d'assurance</span></h3>
                <label>Au cours des 36 derniers {noticeCondSecondaire} avez fait l'objet d'une résiliation par un précédent assureur</label>
                {( params.ant_resiliation=='O' )? this.renderResiliation(container) : '' }
            </>:<></>}

            {(!(antRetrait||antAlcool||antAnnulation||antResiliation||antStupefiants))
            ? <><h2>{noticeCondSecondaire} n'avez déclaré aucun antécédent (retrait, annulation de permis, sanctions sous emprise de l'alcool ou de stupéfiants, résiliations, ...)</h2>
            </>
            :''}
            {this.renderGoToAntecedents()}

            { !!params.nb_mois_moto &&
            <><h1>Votre précédent assureur Moto</h1>
                <FieldAssureurs container={container} field="previous_insurer" />
                {( params.previous_insurer == 'AXA' )&&<FieldText field="previous_insurer_axa_num" container={container}/>}
                {( params.previous_insurer == 'AUTR' )&&<FieldText field="previous_insurer_autre" container={container}/>}
                <FieldDate field="previous_insurer_term" container={container} notice="Laissez vide si la date n'est pas encore connue"/>
                <FieldYesNo field="previous_insurer_term_company" container={container} />
                <FieldDate field="previous_insurer_term_date" container={container} />
                <FieldText field="previous_insurer_immat" container={container} />
                <FieldText field="coefficient_moto" container={container}/>
                <i>Entre 50 (bonus maximal) et 350 (malus maximal)</i>
            </>}
            {(Number(params.coefficient_moto) === 50 )&&
                <FieldNumeric min="0" max="50" field="nb_ans_bonus_50_moto" container={container} />}                
            </div>
            
            <div className="contentvbox">

            <h1 className="top_title">Souscription</h1>

            <FieldDate field="date_effet" container={container} />
            
            <FieldText field="numero_permis" container={container} noCheck={unsync} logo={logo_permis}/>
            <FieldText field="immatriculation" notice="Exemple: XX123XX" container={container} noCheck={unsync} logo={logo_immatriculation} logoClass="immatriculation"/>

            <div className="notice_box">
                <div className="img_box"><img src={img_lamp}/></div>
                <div className="text_box">
                    <h3>Le numéro d'immatriculation se trouve dans la section A de votre carte grise !</h3>
                    Pour un véhicule neuf, vous pouvez indiquer le numéro d'immatriculation provisoire. 
                    <b> N'oubliez pas de nous fournir le numéro définitif dès que vous l'obtenez.</b>
                </div>
            </div>

            <FieldText field="iban" 
                logo={logo_right}
                container={container} 
                placeholder="27 caractères commençant par FR"
                noCheck={unsync}/>

            

            <FieldCheck field="own_iban" container={container} noCheck={unsync} disabled={!devis.getValue('iban','').trim()}/>
            <FieldCheck field="accept_cgu" container={container}/>

            {hasAxa?<>
                <div className="notice_box">
                    <div className="img_box"><img src={img_cb}/></div>
                    <div className="text_box">
                        <p>
                        Dès la validation du paiement, le montant de <b>{axa.fancyPrice(axa.frais)}</b>
                        qui correspond aux frais de gestion et de courtage sera débité
                        de votre carte bancaire.
                        </p>
                        <p>
                        Puis un justificatif d'assurance vous sera envoyé. Votre véhicule
                        sera ensuite inscrit dans le <strong>Fichier des Véhicules Assurés (FVA) </strong>
                        sous <b>72 heures.</b>
                        </p>
                    </div>
                </div>

            </>:<></>}

            { this.props.embeded
            ? <FieldSelect 
                    field="frais_sup" container={container} options={devis.getOptionsFraisSup(api.isAdmin())} 
                    label={<>Les frais de base pour ce type de véhicule sont de <b>{axa.frais}</b>.<br/>Vous pouvez appliquer des frais supplémentaires, dans la limite de {devis.max_frais} de frais totaux :</>}
                /> : ''}

            { unsync
            ? <p>Vos informations ont changé. Cliquez sur "Valider" pour régénérer le devis.</p> 
            : hasAxa ? <><div className="standalone_prices notice_box">
                    <div className="img_box"><img src={img_cb}/></div>
                    <div className="text_box">
                    {(params.periodicite=='M')?<>
                        <div className="price_row"><b>{axa.fancyPrice(axa.echeanceOptions())}</b> par mois*</div>
                        <div className="price_row"><b>{axa.fancyPrice(axa.coutTotal())}</b> par an TTC*</div>
                    </>:<>
                        <div className="price_row"><b>{axa.fancyPrice(axa.coutTotal())}</b> par an TTC*</div>
                    </>}
                    <p>* Frais de gestion et courtage inclus.<br/>
                    {(params.periodicite=='M')?<>
                    L'acompte de <b>{axa.fancyPrice(axa.frais)}</b> comprend les frais de gestion et de courtage renouvelables chaque année. <br/>
                    Un premier prélèvement de <b>{axa.fancyPrice(axa.perception())}</b> interviendra dans une quinzaine de jours.
                    Il comprend le mois en cours, le mois suivant, ainsi que la taxe attentat de <b>{axa.fancyPrice(6.5)}</b>. Puis, par mois, à
                    partir du 3ème mois : <b>{axa.fancyPrice(axa.echeanceOptionsSansFrais())}</b></>:<>
                    L'acompte de <b>{axa.fancyPrice(axa.frais)}</b> comprend les frais de gestion et de courtage renouvelables chaque année. <br/>
                    Un premier prélèvement de <b>{axa.fancyPrice(axa.perception())}</b> interviendra dans une quinzaine de jours. 
                    Il comprend le mois en cours et les 11 suivants, ainsi que la taxe attentat de <b>{axa.fancyPrice(6.5)}</b>.
                    
                    </>}
                    </p>

                    </div>

                </div>
                {(!axa.valid_address)&&<div className="notice_box">
                    <div className="img_box"><img src={cadenas}/></div>
                    <div className="text_box">
                        L'adresse postale est invalide (nom de rue incorrect ou adresse mal formée).                        
                    <a className="right_anchor" onClick={()=>this.props.setPage('vous')}>Merci de vérifier votre adresse ici</a>
                    </div>
                </div>}

                {axa.valid_address && <div>
                    <h2 className="clickbox"
                        onClick={()=>this.setState(state=>({collapseEcheancier:!state.collapseEcheancier}))}
                    >
                        <img src={echeancier}/> 
                        Votre <b>échéancier</b>
                        <img className="right_switch" src={this.state.collapseEcheancier ? arrow_down : arrow_up}/>
                    </h2>

                    <FrontEcheancierAxa container={container} hidden={this.state.collapseEcheancier}/>

                                
                </div>}</>
                : <div className="standalone_prices notice_box">
                    <div className="text_box centered">
                        {!!axa.calculating && <p>Nous recalculons votre devis, merci de patienter quelques secondes ...</p>}
                        
                        {axa.error && <><p className="error">Une erreur est survenue : {axa.getCleanError()}.</p> 
                        <ul>
                            {(axa.error=='logout')
                                ? <li>Vous pouvez revenir plus tard,</li>
                                : <li>Vous pouvez modifier vos informations et relancer le calcul du devis,</li>}
                            <li>Ou contacter nos conseillers au
                                <p className="telephone_left">
                                <a href="tel:0974772861">09 74 77 28 61</a>
                                </p>
                            </li>
                        </ul>
                        </>}

                        {((!axa.error)&&(!axa.hasTarifs())&&(!axa.calculating))&&<p>Cette formule n'est pas disponible. Vous pouvez en choisir une autre en revenant à la page précédente.</p>}
                    </div>
                </div>
            }
            </div>

        </>
    }
}
